/** Concox LL303*/
export const device_1008 = [
  {
    N: 1,
    powermode: 1,
    description: 'Mode 1 - Timing Positioning Mode',
    fields: {
      T: {
        description: 'Location Interval',
        default: 10,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        tooltip: '0 (disable automatic upload)',
        type: 'group-input',
        uom: 'second(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      D: {
        description: 'BLE Switch',
        default: 0,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T', 'A', 'B', 'C', 'D'],
      separator: ',',
      suffix: '#',
    },
  },
  {
    N: 2,
    powermode: null,
    description: 'Mode 2 - Intelligent Positioning Mode',
    fields: {
      T1: {
        description: 'Location Interval (moving)',
        default: 20,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        type: 'group-input',
        uom: 'second(s)',
      },
      T2: {
        description: 'Location Interval (static)',
        default: 0,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        tooltip: '0 (no uploading at rest). 180 - 86400s available when GPSDUP is enabled;',
        type: 'group-input',
        uom: 'second(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
        tooltip:
          'If A = 0, only expansion is reserved. Exhibition, not as a function of 0 for the time being. ',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      D: {
        description: 'BLE Switch',
        default: 0,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      E: {
        description: 'GPRS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
        tooltip: 'When idle 1 = GPRS alwys on',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2', 'A', 'B', 'C', 'D', 'E'],
      separator: ',',
      suffix: '#',
    },
  },
  {
    N: 3,
    powermode: 1,
    description: 'Mode 3 - Battery Saving Mode',
    fields: {
      T1: {
        type: 'date-picker',
        description: 'Starting Time',
        default: '00:00',
        validation: 'time:HH:MM',
        placeholder: 'Masukkan input dengan format HH:MM',
      },
      T2: {
        description: 'Time Interval',
        default: 5,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan menit',
        type: 'group-input',
        uom: 'minute(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      D: {
        description: 'BLE Switch',
        default: 0,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2', 'A', 'B', 'C', 'D'],
      separator: ',',
      suffix: '#',
    },
  },
]

/** Concox LL301*/
export const device_1004 = [
  {
    N: 1,
    powermode: 1,
    description: 'Mode 1 - Timing Positioning Mode',
    fields: {
      T: {
        description: 'Location Interval',
        default: 10,
        validation: 'number|required',
        placeholder: 'Masukkan input dalam satuan detik',
        tooltip: '0 (disable automatic upload)',
        type: 'group-input',
        uom: 'second(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T', 'A', 'B', 'C'],
      separator: ',',
      suffix: '#',
    },
  },
  {
    N: 2,
    powermode: null,
    description: 'Mode 2 - Intelligent Positioning Mode',
    fields: {
      T1: {
        description: 'Location Interval (moving)',
        default: 20,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        type: 'group-input',
        uom: 'second(s)',
      },
      T2: {
        description: 'Location Interval (static)',
        default: 0,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        tooltip: '0 (no uploading at rest). 180 - 86400s available when GPSDUP is enabled;',
        type: 'group-input',
        uom: 'second(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
        tooltip:
          'If A = 0, only expansion is reserved. Exhibition, not as a function of 0 for the time being. ',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      D: {
        description: 'GPRS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
        tooltip: 'When idle 1 = GPRS alwys on',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2', 'A', 'B', 'C', 'D'],
      separator: ',',
      suffix: '#',
    },
  },
  {
    N: 3,
    powermode: 1,
    description: 'Mode 3 - Battery Saving Mode',
    fields: {
      T1: {
        type: 'date-picker',
        description: 'Starting Time',
        default: '00:00',
        validation: 'time:HH:MM',
        placeholder: 'Masukkan input dengan format HH:MM',
      },
      T2: {
        description: 'Time Interval',
        default: 5,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan menit',
        type: 'group-input',
        uom: 'minute(s)',
      },
      A: {
        description: 'GPS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      B: {
        description: 'WIFI Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
      C: {
        description: 'LBS Switch',
        default: 1,
        validation: 'required|number|min:0,value|max:1,value',
        placeholder: 'Masukkan input antara 0 dan 1',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2', 'A', 'B', 'C'],
      separator: ',',
      suffix: '#',
    },
  },
]

/** Concox AT4*/
export const device_1005 = [
  {
    N: 1,
    powermode: 1,
    description: 'Mode 1 - Tracking Mode',
    fields: {
      T1: {
        description: 'Location Interval (moving)',
        default: 20,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        type: 'group-input',
        uom: 'second(s)',
      },
      T2: {
        description: 'Location Interval (static)',
        default: 180,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan detik',
        tooltip: '0 (no uploading at rest). 180 - 86400s available when GPSDUP is enabled;',
        type: 'group-input',
        uom: 'second(s)',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2'],
      separator: ',',
      suffix: '#',
    },
  },
  {
    N: 2,
    powermode: 1,
    description: 'Mode 2 - Battery Saving Mode',
    fields: {
      T1: {
        type: 'date-picker',
        description: 'Starting Time',
        default: '00:00',
        validation: 'time:HH:MM',
        placeholder: 'Masukkan input dengan format HH:MM',
      },
      T2: {
        description: 'Time Interval',
        default: 24,
        validation: 'required|number',
        placeholder: 'Masukkan input dalam satuan jam',
        type: 'group-input',
        uom: 'hour(s)',
      },
    },
    formula: {
      prefix: 'MODE,',
      body: ['N', 'T1', 'T2'],
      separator: ',',
      suffix: '#',
    },
  },
]